"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var fabric_1 = require("fabric");
var Base_1 = __importDefault(require("./Base"));
var constants_1 = require("../common/constants");
var safe_zone_1 = require("../utils/safe-zone");
var DEFAULT_SAFE_ZONE_CONFIG = {
    enabled: false,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    type: "none",
};
var SafeZone = /** @class */ (function (_super) {
    __extends(SafeZone, _super);
    function SafeZone(props) {
        var _this = _super.call(this, props) || this;
        _this.config = DEFAULT_SAFE_ZONE_CONFIG;
        _this.onObjectMoving = function (event) {
            if (!event.target || !_this.isEnabled()) {
                return;
            }
            _this.fitTargetToSafeZone(event.target);
        };
        _this.onObjectScaling = function (event) {
            if (!event.target || !_this.isEnabled()) {
                return;
            }
            _this.fitTargetToSafeZone(event.target);
        };
        _this.initialize(_this.canvas);
        return _this;
    }
    SafeZone.prototype.setConfig = function (config) {
        this.config = config ? __assign({}, config) : __assign({}, DEFAULT_SAFE_ZONE_CONFIG);
    };
    SafeZone.prototype.getConfig = function () {
        return this.config;
    };
    SafeZone.prototype.fitSceneToSafeZone = function () {
        if (!this.isEnabled()) {
            return false;
        }
        var objects = this.getSceneObjects();
        if (!objects.length) {
            return false;
        }
        var wasAdjusted = this.config.type === "cover" ? this.fitCoverObjectsToSafeZone(objects) : this.fitObjectsToSafeZone(objects);
        if (wasAdjusted) {
            this.canvas.requestRenderAll();
        }
        return wasAdjusted;
    };
    SafeZone.prototype.handleObjectModified = function (target) {
        if (!target || !this.isEnabled()) {
            return false;
        }
        return this.fitTargetToSafeZone(target);
    };
    SafeZone.prototype.initialize = function (canvas) {
        canvas.on("object:moving", this.onObjectMoving);
        canvas.on("object:scaling", this.onObjectScaling);
    };
    SafeZone.prototype.isEnabled = function () {
        var _a, _b;
        return !!((_a = this.config) === null || _a === void 0 ? void 0 : _a.enabled) && ((_b = this.config) === null || _b === void 0 ? void 0 : _b.type) !== "none";
    };
    SafeZone.prototype.getFrameOrigin = function () {
        var frame = this.editor.frame.frame;
        return {
            left: (frame === null || frame === void 0 ? void 0 : frame.left) || 0,
            top: (frame === null || frame === void 0 ? void 0 : frame.top) || 0,
        };
    };
    SafeZone.prototype.getSceneObjects = function () {
        return this.canvas.getObjects().filter(function (object) {
            if (!object || object.visible === false) {
                return false;
            }
            return object.type !== constants_1.LayerType.FRAME && object.type !== constants_1.LayerType.BACKGROUND && object.type !== constants_1.LayerType.BACKGROUND_IMAGE;
        });
    };
    SafeZone.prototype.getLocalBounds = function (target) {
        var _a = this.getFrameOrigin(), frameLeft = _a.left, frameTop = _a.top;
        var bounds = target.getBoundingRect(true, true);
        return {
            left: bounds.left - frameLeft,
            top: bounds.top - frameTop,
            width: bounds.width,
            height: bounds.height,
        };
    };
    SafeZone.prototype.getBoundsUnionForObjects = function (objects) {
        var _this = this;
        var bounds = objects
            .map(function (object) { return _this.getLocalBounds(object); })
            .filter(function (bound) { return bound.width >= 0 && bound.height >= 0; });
        return (0, safe_zone_1.getBoundsUnion)(bounds);
    };
    SafeZone.prototype.getBoundsCenter = function (bounds) {
        return {
            x: bounds.left + bounds.width / 2,
            y: bounds.top + bounds.height / 2,
        };
    };
    SafeZone.prototype.getInsideSafeZone = function () {
        return {
            left: this.config.left,
            top: this.config.top,
            right: this.config.right,
            bottom: this.config.bottom,
        };
    };
    SafeZone.prototype.getCoverRegions = function () {
        return this.config.regions || [];
    };
    SafeZone.prototype.getRegionById = function (regionId) {
        return this.getCoverRegions().find(function (region) { return region.id === regionId; }) || null;
    };
    SafeZone.prototype.getNearestRegion = function (bounds, regions) {
        var _a;
        if (!regions.length) {
            return null;
        }
        var center = this.getBoundsCenter(bounds);
        return ((_a = regions.reduce(function (closest, region) {
            var regionCenter = {
                x: (region.left + region.right) / 2,
                y: (region.top + region.bottom) / 2,
            };
            var distance = Math.hypot(center.x - regionCenter.x, center.y - regionCenter.y);
            if (!closest || distance < closest.distance) {
                return { region: region, distance: distance };
            }
            return closest;
        }, null)) === null || _a === void 0 ? void 0 : _a.region) || null;
    };
    SafeZone.prototype.getObjectCoverRegionId = function (target) {
        var metadata = (target === null || target === void 0 ? void 0 : target.metadata) || {};
        if (metadata.isDropTarget && metadata.coverRegion === "back") {
            return "back-safe";
        }
        if (metadata.isDropTarget && metadata.coverRegion === "front") {
            return "front-safe";
        }
        if (target.name === "Spine Text") {
            return "spine";
        }
        return null;
    };
    SafeZone.prototype.isCoverPhotoTarget = function (target) {
        var metadata = (target === null || target === void 0 ? void 0 : target.metadata) || {};
        return !!metadata.isDropTarget && (metadata.coverRegion === "back" || metadata.coverRegion === "front");
    };
    SafeZone.prototype.getActiveSelectionCoverRegionId = function (target) {
        var _this = this;
        var objects = target === null || target === void 0 ? void 0 : target._objects;
        if (!(objects === null || objects === void 0 ? void 0 : objects.length)) {
            return null;
        }
        var regionIds = Array.from(new Set(objects.map(function (object) { return _this.getObjectCoverRegionId(object); }).filter(function (regionId) { return !!regionId; })));
        if (regionIds.length === 1) {
            return regionIds[0];
        }
        return null;
    };
    SafeZone.prototype.getCoverSafeZoneForTarget = function (target) {
        var _this = this;
        var explicitRegionId = target.type === constants_1.LayerType.ACTIVE_SELECTION
            ? this.getActiveSelectionCoverRegionId(target)
            : this.getObjectCoverRegionId(target);
        if (explicitRegionId) {
            return this.getRegionById(explicitRegionId);
        }
        var bounds = this.getLocalBounds(target);
        var regions = this.getCoverRegions().filter(function (region) {
            return ["back-safe", "front-safe", "spine"].includes(region.id);
        });
        var containingRegion = regions.find(function (region) {
            var center = _this.getBoundsCenter(bounds);
            return center.x >= region.left && center.x <= region.right && center.y >= region.top && center.y <= region.bottom;
        });
        if (containingRegion) {
            return containingRegion;
        }
        return this.getNearestRegion(bounds, regions);
    };
    SafeZone.prototype.getSafeZoneForTarget = function (target) {
        if (this.config.type === "inside") {
            return this.getInsideSafeZone();
        }
        if (this.config.type === "cover") {
            return this.getCoverSafeZoneForTarget(target);
        }
        return null;
    };
    SafeZone.prototype.fillTargetToRegion = function (target, region) {
        if (!target.width || !target.height) {
            return false;
        }
        var _a = this.getFrameOrigin(), frameLeft = _a.left, frameTop = _a.top;
        var originX = (target.originX || "left");
        var originY = (target.originY || "top");
        var left = frameLeft + region.left;
        var top = frameTop + region.top;
        var right = frameLeft + region.right;
        var bottom = frameTop + region.bottom;
        target.set({
            scaleX: (right - left) / target.width,
            scaleY: (bottom - top) / target.height,
        });
        target.setPositionByOrigin(new fabric_1.fabric.Point(left, top), "left", "top");
        target.originX = originX;
        target.originY = originY;
        target.setCoords();
        return true;
    };
    SafeZone.prototype.scaleTargetAroundCenter = function (target, factor) {
        if (!Number.isFinite(factor) || factor >= 1 || factor <= 0) {
            return false;
        }
        var center = target.getCenterPoint();
        target.set({
            scaleX: (target.scaleX || 1) * factor,
            scaleY: (target.scaleY || 1) * factor,
        });
        target.setPositionByOrigin(center, "center", "center");
        target.setCoords();
        return true;
    };
    SafeZone.prototype.translateTarget = function (target, dx, dy) {
        if (!dx && !dy) {
            return false;
        }
        var center = target.getCenterPoint();
        target.setPositionByOrigin(new fabric_1.fabric.Point(center.x + dx, center.y + dy), "center", "center");
        target.setCoords();
        return true;
    };
    SafeZone.prototype.scaleObjectsAroundCenter = function (objects, factor, unionBounds) {
        if (!Number.isFinite(factor) || factor >= 1 || factor <= 0) {
            return false;
        }
        var _a = this.getFrameOrigin(), frameLeft = _a.left, frameTop = _a.top;
        var compositionCenter = {
            x: frameLeft + unionBounds.left + unionBounds.width / 2,
            y: frameTop + unionBounds.top + unionBounds.height / 2,
        };
        objects.forEach(function (object) {
            var center = object.getCenterPoint();
            var nextCenter = new fabric_1.fabric.Point(compositionCenter.x + (center.x - compositionCenter.x) * factor, compositionCenter.y + (center.y - compositionCenter.y) * factor);
            object.set({
                scaleX: (object.scaleX || 1) * factor,
                scaleY: (object.scaleY || 1) * factor,
            });
            object.setPositionByOrigin(nextCenter, "center", "center");
            object.setCoords();
        });
        return true;
    };
    SafeZone.prototype.translateObjects = function (objects, dx, dy) {
        if (!dx && !dy) {
            return false;
        }
        objects.forEach(function (object) {
            var center = object.getCenterPoint();
            object.setPositionByOrigin(new fabric_1.fabric.Point(center.x + dx, center.y + dy), "center", "center");
            object.setCoords();
        });
        return true;
    };
    SafeZone.prototype.fitTargetToSafeZone = function (target) {
        var safeZone = this.getSafeZoneForTarget(target);
        if (!safeZone) {
            return false;
        }
        if (this.config.type === "cover" && this.isCoverPhotoTarget(target)) {
            return this.fillTargetToRegion(target, safeZone);
        }
        var wasAdjusted = false;
        var bounds = this.getLocalBounds(target);
        if ((0, safe_zone_1.hasRectOverflow)(bounds, safeZone)) {
            var scaleFactor = (0, safe_zone_1.getFitScaleFactor)(bounds, safeZone);
            if (scaleFactor < 1) {
                wasAdjusted = this.scaleTargetAroundCenter(target, scaleFactor) || wasAdjusted;
                bounds = this.getLocalBounds(target);
            }
            var _a = (0, safe_zone_1.getClampDelta)(bounds, safeZone), dx = _a.dx, dy = _a.dy;
            if (dx || dy) {
                wasAdjusted = this.translateTarget(target, dx, dy) || wasAdjusted;
            }
        }
        return wasAdjusted;
    };
    SafeZone.prototype.fitObjectsToSafeZone = function (objects) {
        var safeZone = this.getInsideSafeZone();
        var wasAdjusted = false;
        var bounds = this.getBoundsUnionForObjects(objects);
        if (!bounds || !(0, safe_zone_1.hasRectOverflow)(bounds, safeZone)) {
            return false;
        }
        var scaleFactor = (0, safe_zone_1.getFitScaleFactor)(bounds, safeZone);
        if (scaleFactor < 1) {
            wasAdjusted = this.scaleObjectsAroundCenter(objects, scaleFactor, bounds) || wasAdjusted;
            bounds = this.getBoundsUnionForObjects(objects);
        }
        if (!bounds) {
            return wasAdjusted;
        }
        var _a = (0, safe_zone_1.getClampDelta)(bounds, safeZone), dx = _a.dx, dy = _a.dy;
        if (dx || dy) {
            wasAdjusted = this.translateObjects(objects, dx, dy) || wasAdjusted;
        }
        return wasAdjusted;
    };
    SafeZone.prototype.fitCoverObjectsToSafeZone = function (objects) {
        var _this = this;
        var wasAdjusted = false;
        objects.forEach(function (object) {
            wasAdjusted = _this.fitTargetToSafeZone(object) || wasAdjusted;
        });
        return wasAdjusted;
    };
    return SafeZone;
}(Base_1.default));
exports.default = SafeZone;
//# sourceMappingURL=SafeZone.js.map